export const RING = [
  {
    name: 'Ultor Ring',
    slot: 'ring',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Attack', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 12, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Venator Ring',
    slot: 'ring',
    regions: ['Desert'],
    requirements: [{ skill: 'Ranged', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 10 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 2, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Magus Ring',
    slot: 'ring',
    regions: ['Fremennik'],
    requirements: [{ skill: 'Magic', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 15, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 2, prayer: 0 },
    },
  },
  {
    name: 'Bellator Ring',
    slot: 'ring',
    regions: ['Asgarnia'],
    requirements: [{ skill: 'Attack', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 20, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 6, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Ring of Suffering (i)',
    slot: 'ring',
    regions: ['Kourend'],
    requirements: [{ skill: 'Defence', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 20, slash: 20, crush: 20, magic: 20, ranged: 20 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 4 },
    },
  },
  {
    name: 'Berserker Ring (i)',
    slot: 'ring',
    regions: ['Fremennik'],
    requirements: [{ skill: 'Attack', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 8, magic: 0, ranged: 0 },
      other:   { meleeStrength: 8, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Archers Ring (i)',
    slot: 'ring',
    regions: ['Fremennik'],
    requirements: [{ skill: 'Ranged', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 8 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 8 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Seers Ring (i)',
    slot: 'ring',
    regions: ['Fremennik'],
    requirements: [{ skill: 'Magic', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 12, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 12, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0.5, prayer: 0 },
    },
  },
  {
    name: 'Ring of the Gods (i)',
    slot: 'ring',
    regions: ['Wilderness'],
    requirements: [{ skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 1, slash: 1, crush: 1, magic: 1, ranged: 1 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 8 },
    },
  },
  {
    name: 'Brimstone Ring',
    slot: 'ring',
    regions: ['Kourend'],
    requirements: [{ skill: 'Slayer', level: 75 }],
    bonuses: {
      attack:  { stab: 4, slash: 4, crush: 4, magic: 6, ranged: 4 },
      defence: { stab: 4, slash: 4, crush: 4, magic: 6, ranged: 4 },
      other:   { meleeStrength: 4, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Lightbearer',
    slot: 'ring',
    regions: ['Desert'],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Treasonous Ring (i)',
    slot: 'ring',
    regions: ['Wilderness'],
    requirements: [{ skill: 'Attack', level: 75 }],
    bonuses: {
      attack:  { stab: 8, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 8, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Tyrannical Ring (i)',
    slot: 'ring',
    regions: ['Wilderness'],
    requirements: [{ skill: 'Attack', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 8, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 8, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Granite Ring (i)',
    slot: 'ring',
    regions: ['Fremennik'],
    requirements: [{ skill: 'Defence', level: 50 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 4, slash: 4, crush: 4, magic: -4, ranged: 24 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Ring of Shadows',
    slot: 'ring',
    regions: ['Desert'],
    requirements: [],
    bonuses: {
      attack:  { stab: 4, slash: 4, crush: 4, magic: 5, ranged: 4 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 5, ranged: 0 },
      other:   { meleeStrength: 2, rangedStrength: 0, magicDamage: 0, prayer: 2 },
    },
  },
  {
    name: 'Ring of Recoil',
    slot: 'ring',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Ring of Endurance',
    slot: 'ring',
    regions: ['Morytania'],
    requirements: [{ skill: 'Agility', level: 60 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
];
